import Helmet from 'react-helmet';
import type { FunctionComponent } from 'react';

import type { RouterProps } from '../../types';

import SettingsNavigation from './SettingsNavigation';

/**
 * SettingsContainer is the top-level wrapper component for all the settings pages.
 * It replaces the monolithic AccountSettingsPage, but unlike that component,
 * this one is not stateful and simply renders the subnav and whatever child components
 * are declared as child routes. See each of the pages Container components, which
 * are responsible for rendering the SidebarNav and actual content of the page.
 */
const SettingsContainer: FunctionComponent<RouterProps> = ({ children, location }) => (
  <>
    <Helmet title="Settings" />
    <SettingsNavigation pathname={location.pathname} />
    {children}
  </>
);

export default SettingsContainer;
